var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w100 bgWhite"},[_c('article',{staticClass:"wContent center",staticStyle:{"padding-top":"20px"}},[_c('QuoteControl')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }